import { Flex, FlexProps } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Text from 'components/shared/Text';
import CustomLink from 'components/shared/form/CustomLink';
import { formatPhone } from 'utils/formatPhone';

type Props = FlexProps & {
  title: string;
  fullName: string;
  phone: string;
  link?: string;
  className?: string;
  onClick?: () => void;
};

const MeetingContact: React.FC<Props> = ({ title, fullName, phone, link, className, onClick, ...props }) => {
  return (
    <Flex gap="xxxs" direction="column" className={className} {...props}>
      <Text size="sm" c="gray.6">
        {title}
      </Text>
      <Flex gap="xxxxs" direction="column">
        {link ? (
          <CustomLink as="link" href={link} label={fullName} />
        ) : onClick ? (
          <CustomLink as="button" onClick={onClick} label={fullName} />
        ) : (
          <Text>{fullName}</Text>
        )}
        <Text>{formatPhone(phone)}</Text>
      </Flex>
    </Flex>
  );
};

export default observer(MeetingContact);
